import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DOMPurify from "dompurify";
import "./UpdateReview.css";
import { routePath } from "../../app/routes/routepath";
import { CommonStatus, contentCategoryId } from "../../app/Enums/StatusEnums";
import { toast } from "react-toastify";
import { ActionOnContentUpdateReq } from "../../api/ContentApi/contentApi";
import RejectBlogModal from "../../app/components/FeedbackModal/RejectBlogModal/RejectBlogModal";
import { RoleId } from "../../app/Enums/RoleId";
export default function UpdateReview() {
  const navigate = useNavigate();
  const location = useLocation();
  const contentData = location.state?.content;
  const contentCategory = location.state?.category;
  const adminId = localStorage.getItem("UserId");
  const [showRejectBlogModal, setshowRejectBlogModal] = useState(false);
  const [reasonOfRejection, setReasonOfRejection] = useState(null);
  const roleId = Number(localStorage.getItem("RoleId"));
  const [isProcessing, setIsProcessing] = useState(false);
  console.log(contentData);

  const handleBack = () => {
    if (contentCategory == contentCategoryId.blog) {
      navigate(routePath.userBlog);
    } else {
      navigate(routePath.userArticle);
    }
  };

  const handelUpdateAccept = () => {
    handleAcceptUpdateReq();
  };
  const handleAcceptUpdateReq = async () => {
    const data = {
      contentId: contentData.contentId,
      categoryId: contentCategory,
      statusId: CommonStatus.Approved,
      adminId: adminId,
      rejectionReason: reasonOfRejection,
    };
    setIsProcessing(true);
    try {
      var response = await ActionOnContentUpdateReq(data);
      if (response?.data.result == 1) {
        toast.success("Accepted udpated request successfully");
        navigate(-1);
      } else {
        toast.error("Something went wrong please try again");
      }
    } catch (error) {
      toast.error("Something went wrong please try again");
    } finally {
      setIsProcessing(false);
    }
  };

  const handelUpdateRejection = () => {
    setshowRejectBlogModal(true);
    // handleRejectUpdateReq();
  };

  const handleRejectUpdateReq = async (reason) => {
    const data = {
      contentId: contentData.contentId,
      categoryId: contentCategory,
      statusId: CommonStatus.Rejected,
      adminId: adminId,
      rejectionReason: reason,
    };
    try {
      var response = await ActionOnContentUpdateReq(data);
      console.log(response);
      if (response?.data.result == 1) {
        toast.success("Rejected successfully");
        setshowRejectBlogModal(false);
        navigate(-1);
      } else {
        toast.error("Failed to reject");
      }
    } catch (error) {
      toast.error("Something went wrong please try again");
    } finally {
    }
  };

  console.log(contentData, "nnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnn");
  if (!contentData) {
    return <p>No data found.</p>;
  }

  return (
    <>
      <div className="role-box">
        <ul className="breadcumb">
          <li className="active" onClick={handleBack}>
            <i className="bi bi-file-earmark-richtext"></i>
            {contentCategory === contentCategoryId.blog ? (
              <span>Blog</span>
            ) : (
              <span>Article</span>
            )}
          </li>

          <li className="dash-arrow">/</li>

          <li>
            {contentCategory === contentCategoryId.blog ? (
              <span>View Update Request Blog</span>
            ) : (
              <span>View Update Request Article</span>
            )}
          </li>
        </ul>
      </div>

      <div className="main_container">
        {roleId === RoleId.Admin && (
          <div className="d-flex align-items-center mb-20">
            <button className="primary_btn" onClick={handelUpdateAccept}>
              {isProcessing ? <div className="Accept_spinner"></div> : "Accept"}
            </button>
            <button
              className="secondary_btn ml-10"
              onClick={handelUpdateRejection}
            >
              Reject
            </button>
          </div>
        )}
        <div className="main_widget p-20">
          <div className="main_widget_body blog_preview_widget">
            <div className="blog_post_main_headin_txt">
              <div className="blog_post_preview_cover_img">
                <img
                  src={
                    contentData.updatedCoverImage ||
                    require("../../assets/images/about_banner.jpg")
                  }
                  alt="Cover"
                />
              </div>

              <div className="blog_heading">
                <h2>{contentData.updatedTitle}</h2>
              </div>

              <div className="blog_description">
                <p>{contentData.updatedDescription}</p>
                <div className="blog_post_publish_details">
                  <span>{contentData.userName}</span>
                  {contentData.submittedAt && (
                    <span>
                      Date :{" "}
                      {new Date(contentData.submittedAt).toLocaleDateString()}
                    </span>
                  )}
                </div>
              </div>

              <div
                className="blog_post_content"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(contentData.updatedContent),
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
      {showRejectBlogModal && (
        <RejectBlogModal
          onClose={() => setshowRejectBlogModal(false)}
          onSubmit={(reason) => {
            setReasonOfRejection(reason);
            handleRejectUpdateReq(reason);
          }}
          blogTitle={contentData.updatedTitle}
        />
      )}
    </>
  );
}
